import { dialogDrag } from './dialogDrag';
import copy from './copy';


export default {
    install: (Vue) => {
        Vue.directive('dialogDrag', dialogDrag);
        Vue.directive('copy', copy);
    },
};
